var m = require('mithril');
var moment = require('moment-timezone');
import { Calendar } from '@fullcalendar/core';
import interactionPlugin from '@fullcalendar/interaction';
import momentPlugin from '@fullcalendar/moment';
import rrulePlugin from '@fullcalendar/rrule';
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import timeGridPlugin from '@fullcalendar/timegrid';

var heading = require('../../components/heading');
var io = require('../../libs/socketio');
var directPointSubscription = require('../../components/directPointSubscription');

var component = {};

component.config = function config (ctrl) {
  return function (element, isInitialized, context) {
    if (!isInitialized) {
      context.calendar = ctrl.calendar = new Calendar(element, {
        plugins: [ resourceTimelinePlugin, rrulePlugin, momentPlugin, interactionPlugin ],
        schedulerLicenseKey: 'GPL-My-Project-Is-Open-Source',
        disableMobile: true,
        defaultView: 'resourceTimelineDay',
        nowIndicator: true,
        timeZone: 'local',
        scrollTime: moment().subtract(1, 'hour').format('H:mm:ss'),
        allDaySlot: false,
        titleFormat: 'dddd',
        contentHeight: 120,
        resourceLabelText: 'Calendars',
        selectable: true,
        header: false,
        resources: ctrl.elementRecord.out_Contains[0].in.out_Column.map(function (calendarResource) {
          return {title: calendarResource.name, id: calendarResource.in['@rid'], column: calendarResource['@rid']};
        }),
        events: function (fetchInfo, successCallback, failureCallback) {
          var events = [];
          try {
            ctrl.elementRecord.out_Contains[0].in.out_Column.forEach(function (columnRecord) {
              columnRecord.in.value.forEach(function (eventRecord) {
                eventRecord.column = columnRecord['@rid'];
                events.push(eventRecord);
              })
            });
          } catch (e) {
            // console.log(e)
          } finally {
            successCallback(events);
          }
        },
        dateClick: function(info) {
          m.route.set('/bacnetschedule/' + info.resource.id.slice(1) + '?column=' + info.resource.extendedProps.column )
        },
        eventClick: function (info) {
          var rid = info.event._def.resourceIds[0].slice(1)
          m.route.set('/bacnetschedule/' + rid  + '?column=' + info.event.extendedProps.column)
        }
      });
      context.calendar.render();
    }
  }
};

component.oninit = function (vnode) {
  var ctrl = this;
  ctrl.elementRecord = vnode.attrs.element;
  ctrl.subscriptions = {};

  ctrl.elementRecord.out_Contains[0].in.out_Column.forEach(function (columnRecord) {
    // Subscribe
    directPointSubscription.subscribe(ctrl, columnRecord.in['@rid']);
    // Renew every 20 seconds
    ctrl.subscriptions[columnRecord.in['@rid']] = setInterval(
      directPointSubscription.renew.bind(directPointSubscription, ctrl, columnRecord.in['@rid']),
      20000
    );
  })

  ctrl.handleUpdate = function (data) {
    var matchingColumn = ctrl.elementRecord.out_Contains[0].in.out_Column.find(function (columnRecord) { 
      return columnRecord.in['@rid'] == data['rid'];
    });
    if (matchingColumn) {
      var value;
      if (typeof data.value == 'string') {
        value = JSON.parse(data.value);
      } else {
        value = data.value;
      }

      value.forEach(function (eventRecord) {
        eventRecord.resourceId = matchingColumn.in['@rid'];
      })

      matchingColumn.in.value = value;

      ctrl.calendar.refetchEvents();
    }

  };

  io.on('update', ctrl.handleUpdate);

}

component.onremove = function () {
  var ctrl = this;
  for (var key in ctrl.subscriptions) {
    if (ctrl.subscriptions[key]) {
      clearInterval(ctrl.subscriptions[key]);
    }
  }
  directPointSubscription.release(ctrl);
  io.off('update', ctrl.handleUpdate);
};

component.view = function () {
  var ctrl = this;
  return m('div.f3.narrow', [
    m(heading, {label: ctrl.elementRecord.name, class: 'f1 mb1', element: ctrl.element}),
    m('div', {oninit: component.config(ctrl)})
  ])
}

export default component;
